export default __webpack_public_path__ + "static/media/mars24.301437ed.gif";